"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSISTANCE_SERVICE_FORWARD_PREFIX = void 0;
exports.ASSISTANCE_SERVICE_FORWARD_PREFIX = '/assistance-service';
